module.exports = __webpack_public_path__ + "img/huoimg.467855c6.png";